import React from 'react';
import { SVGIconName, svgIcons } from '../../../constants/svgIcon';

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  name: SVGIconName;
}

export const SvgIcon: React.FC<SvgIconProps> = ({ name, ...props }) => {
  const IconComponent = svgIcons[name];
  return <IconComponent {...props} />;
};
